// Outline helpers derived from explicit canonical section trees.
// Outline helpers derived from explicit canonical section trees.

import type { Section } from '@airhead-games/shared/content';

export interface OutlineItem {
  id: string;
  title: string;
  level: number;
  children: OutlineItem[];
  collapsible?: boolean;
}

const plainText = (
  nodes: Array<{ type: 'text'; text: string } | { children?: unknown }>
): string =>
  nodes
    .map((node) => {
      if ('text' in node) return node.text;
      if ('children' in node && Array.isArray(node.children)) {
        return plainText(node.children as Parameters<typeof plainText>[0]);
      }
      return '';
    })
    .join('');

export const sectionTitleText = (section: Section): string =>
  section.title ? plainText(section.title) : '';

export const buildOutline = (sections: Section[], level = 2): OutlineItem[] =>
  sections
    .filter((section) => section.title)
    .map((section) => ({
      id: section.id,
      title: sectionTitleText(section),
      level,
      collapsible: section.collapsible,
      children: section.sections
        ? buildOutline(section.sections, level + 1)
        : [],
    }));
